
import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '../store'

Vue.use(VueRouter)

import DashboardLayout from 'src/pages/Dashboard/Layout/DashboardLayout.vue'
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue'
import Overview from 'src/pages/Dashboard/Dashboard/Overview.vue'
import Permissions from 'src/pages/Dashboard/Dashboard/Permission/Permissions.vue'
import Permission from 'src/pages/Dashboard/Dashboard/Permission/Permission.vue'
import FeatureFlags from 'src/pages/Dashboard/Dashboard/FeatureFlags.vue'
import FeatureFlag from 'src/pages/Dashboard/Dashboard/FeatureFlag.vue'
import MPago from 'src/pages/Dashboard/Dashboard/MPago.vue'
import Visuais from 'src/pages/Dashboard/Dashboard/Visuais/Visuais.vue'
import Visual from 'src/pages/Dashboard/Dashboard/Visuais/Visual.vue'

import Login from 'src/pages/Dashboard/Pages/Login.vue'
import Recovery from 'src/pages/Dashboard/Pages/Recovery.vue'

import Users from 'src/pages/Dashboard/Dashboard/Users.vue'
import User from 'src/pages/Dashboard/Dashboard/User.vue'

import Password from 'src/pages/Dashboard/Dashboard/Settings/Password.vue'

import Report from 'src/pages/Dashboard/Dashboard/Relatorio.vue'

import Companies from 'src/pages/Dashboard/Dashboard/Companies.vue'
import Company from 'src/pages/Dashboard/Dashboard/Company.vue'
import Matrizes from 'src/pages/Dashboard/Dashboard/Parent/Matrizes.vue'
import Matriz from 'src/pages/Dashboard/Dashboard/Parent/Matriz.vue'

import Products from 'src/pages/Dashboard/Dashboard/Products/Products.vue'
import Product from 'src/pages/Dashboard/Dashboard/Products/Product.vue'
import Categories from 'src/pages/Dashboard/Dashboard/Products/Categories.vue'
import Category from 'src/pages/Dashboard/Dashboard/Products/Category.vue'

import Combos from 'src/pages/Dashboard/Dashboard/Machines/Combos.vue'
import Combo from 'src/pages/Dashboard/Dashboard/Machines/Combo.vue'
import Stock from 'src/pages/Dashboard/Dashboard/Machines/Stock.vue'
import Machines from 'src/pages/Dashboard/Dashboard/Machines/Machines.vue'
import Remote from 'src/pages/Dashboard/Dashboard/Machines/Remote.vue'
import CartRemote from 'src/pages/Dashboard/Dashboard/Machines/CartRemote.vue'
import Sazonal from 'src/pages/Dashboard/Dashboard/Machines/Sazonal.vue'
import Videos from 'src/pages/Dashboard/Dashboard/Machines/Videos.vue'
import Lockers from 'src/pages/Dashboard/Dashboard/Lockers/Lockers.vue'
import Locker from 'src/pages/Dashboard/Dashboard/Lockers/Locker.vue'
import Maintenance from 'src/pages/Dashboard/Dashboard/Machines/Maintenance.vue'
import LockerMainten from 'src/pages/Dashboard/Dashboard/Lockers/Maintenance.vue'
import Machine from 'src/pages/Dashboard/Dashboard/Machines/Machine.vue'
import Shelves from 'src/pages/Dashboard/Dashboard/Machines/Shelves.vue'
import Planograma from 'src/pages/Dashboard/Dashboard/Machines/Planograma.vue'
import Boxes from 'src/pages/Dashboard/Dashboard/Lockers/Boxes.vue'
import Movements from 'src/pages/Dashboard/Dashboard/Machines/Movements.vue'
import Sync from 'src/pages/Dashboard/Dashboard/Machines/Sync.vue'
import Requests from 'src/pages/Dashboard/Dashboard/Machines/Requests.vue'

import Sales from 'src/pages/Dashboard/Dashboard/Sales/Sales.vue'
import Vouchers from 'src/pages/Dashboard/Dashboard/Sales/Vouchers.vue'
import Voucher from 'src/pages/Dashboard/Dashboard/Sales/Voucher.vue'
import Sale from 'src/pages/Dashboard/Dashboard/Sales/Sale.vue'
import Order from 'src/pages/Dashboard/Dashboard/Sales/Order.vue'
import OwnOrders from 'src/pages/Dashboard/Dashboard/Sales/OwnOrders'
import OwnOrder from 'src/pages/Dashboard/Dashboard/Sales/OwnOrder'
import Clients from 'src/pages/Dashboard/Dashboard/Sales/Customers.vue'
import Client from 'src/pages/Dashboard/Dashboard/Sales/Customer.vue'

const routes = [
  {
    path: '/',
    redirect: '/app'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/recovery',
    name: 'Recovery',
    component: Recovery
  },
  // {
  //   path: '/register',
  //   name: 'Registro',
  //   component: Register
  // },
  // {
  //   path: '/lock',
  //   name: 'Lock',
  //   component: Lock
  // },
  {
    path: '/app',
    name: 'App',
    component: DashboardLayout,
    redirect: '/app/overview',
    children: [
      {
        path: '/app/overview',
        name: 'Tela Inicial',
        component: Overview
      },
      // {
      //   path: '/app/manage',
      //   redirect: '/app/manage/users',
      //   children: [
      //     {
      //       path: 'users',
      //       name: 'Usuários',
      //       component: User
      //     }
      //   ]
      // },
      {
        path: '/app/settings/password',
        name: 'Password',
        component: Password
      },
      {
        path: '/app/permissions',
        name: 'Permissão',
        component: Permissions
      },
      {
        path: '/app/mpago',
        name: 'M.Pago',
        component: MPago
      },
      {
        path: '/app/featureflags',
        name: 'Features',
        component: FeatureFlags
      },
      {
        path: '/app/featureflag',
        name: 'Criar Feature',
        component: FeatureFlag
      },
      {
        path: '/app/featureflag/:id',
        name: 'Editar Feature',
        component: FeatureFlag
      },
      {
        path: '/app/permission',
        name: 'Criar Permissão',
        component: Permission
      },
      {
        path: '/app/permission/:id',
        name: 'Editar Permissão',
        component: Permission
      },
      // Produtos
      {
        path: '/app/products/products',
        name: 'Produtos',
        component: Products
      },
      {
        path: '/app/products/product/:id',
        name: 'Editar Produto',
        component: Product
      },
      {
        path: '/app/products/product',
        name: 'Criar Produto',
        component: Product
      },
      // Categorias
      {
        path: '/app/products/categories',
        name: 'Categorias',
        component: Categories
      },
      {
        path: '/app/products/category',
        name: 'Criar Categoria',
        component: Category
      },
      {
        path: '/app/products/category/:id',
        name: 'Editar Categoria',
        component: Category
      },
      // Vending Machines
      {
        path: '/app/machines/machines/',
        name: 'Máquinas',
        component: Machines
      },
      {
        path: '/app/machines/remote/',
        name: 'Remoto',
        component: Remote
      },
      {
        path: '/app/machines/cart-remote/',
        name: 'CarrinhoRemoto',
        component: CartRemote
      },
      {
        path: '/app/machines/sazonal/',
        name: 'Criar Sazonal',
        component: Sazonal
      },
      {
        path: '/app/machines/sazonal/:id',
        name: 'Editar Sazonal',
        component: Sazonal
      },
      {
        path: '/app/machines/videos/',
        name: 'Videos',
        component: Videos
      },
      {
        path: '/app/machines/sync/',
        name: 'Sincronismo',
        component: Sync
      },
      {
        path: '/app/machines/requests/',
        name: 'VM-Requests',
        component: Requests
      },
      {
        path: '/app/machines/machine/',
        name: 'Criar Máquina',
        component: Machine
      },
      {
        path: '/app/machines/machine/:id',
        name: 'Editar Máquina',
        component: Machine
      },
      {
        path: '/app/machines/machine/:id/shelves',
        name: 'Editar Prateleiras',
        component: Shelves
      },
      {
        path: '/app/machines/machine/:id/planograma',
        name: 'Editar Prateleiras',
        component: Planograma
      },
      {
        path: '/app/machines/machine/:id/maintenance/',
        name: 'Manutenção',
        component: Maintenance
      },
      {
        path: '/app/machines/lockers/',
        name: 'Lockers',
        component: Lockers
      },
      {
        path: '/app/machines/locker/',
        name: 'Criar Locker',
        component: Locker
      },
      {
        path: '/app/machines/locker/:id',
        name: 'Editar Locker',
        component: Locker
      },
      {
        path: '/app/machines/locker/:id/boxes',
        name: 'Editar Boxes',
        component: Boxes
      },
      {
        path: '/app/machines/locker/:id/maintenance/',
        name: 'Manutenção',
        component: LockerMainten
      },
      // Estoque
      {
        path: '/app/machines/stock/',
        name: 'Estoque',
        component: Stock
      },
      // Combos
      {
        path: '/app/machines/combos/',
        name: 'Combos',
        component: Combos
      },
      {
        path: '/app/machines/combo/',
        name: 'Criar Combo',
        component: Combo
      },
      {
        path: '/app/machines/combo/:id',
        name: 'Editar Combo',
        component: Combo
      },
      // Movimentos
      {
        path: '/app/machines/movements/',
        name: 'Movimentos',
        component: Movements
      },
      // Voucher
      {
        path: '/app/sales/vouchers/',
        name: 'Cupons',
        component: Vouchers
      },
      {
        path: '/app/sales/voucher/',
        name: 'Criar Cupom',
        component: Voucher
      },
      // Sales
      {
        path: '/app/sales/sales/',
        name: 'Vendas',
        component: Sales
      },
      {
        path: '/app/sales/sale/',
        name: 'Criar Venda',
        component: Sale
      },
      {
        path: '/app/sales/sale/:id',
        name: 'Editar Venda',
        component: Sale
      },
      // pedidos Itaú 
      {
        path: '/app/sales/pedidos/',
        name: 'Pedidos',
        component: Order
      },
      // pedidos do sistema ( para NAVA )
      {
        path: '/app/sales/pedidosSistema/',
        name: 'PedidosSistema',
        component: OwnOrders
      },
      {
        path: '/app/sales/pedidoSistema/',
        name: 'Criar pedido',
        component: OwnOrder
      },
      // Clients
      {
        path: '/app/sales/customers/',
        name: 'Clientes',
        component: Clients
      },
      {
        path: '/app/sales/customer/',
        name: 'Criar Cliente',
        component: Client
      },
      {
        path: '/app/sales/customer/:id',
        name: 'Editar Cliente',
        component: Client
      },
      // relatórios
      {
        path: '/app/report',
        name: 'Relatórios',
        component: Report
      },
      {
        path: '/app/users',
        name: 'Usuários',
        component: Users
      },
      {
        path: '/app/user',
        name: 'Criar Usuário',
        component: User
      },
      {
        path: '/app/user/:id',
        name: 'Editar Usuário',
        component: User
      },
      {
        path: '/app/companies',
        name: 'Empresas',
        component: Companies
      },
      {
        path: '/app/company',
        name: 'Criar Empresa',
        component: Company
      },
      {
        path: '/app/company/:id',
        name: 'Editar Empresa',
        component: Company
      },
      {
        path: '/app/matrizes',
        name: 'Matriz',
        component: Matrizes
      },
      {
        path: '/app/matriz',
        name: 'Criar Matriz',
        component: Matriz
      },
      {
        path: '/app/matriz/:id',
        name: 'Editar Matriz',
        component: Matriz
      },
      {
        path: '/app/visuais',
        name: 'Visuais',
        component: Visuais
      },
      {
        path: '/app/visual',
        name: 'Criar Visual',
        component: Visual
      },
      {
        path: '/app/visual/:id',
        name: 'Editar Visual',
        component: Visual
      },
    ]
  },
  { path: '*', component: NotFound }
]

const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  if (!store.state.auth.authenticated && to.path !== '/login' && to.path !== '/recovery') {
    next('/login')
  } else {
    next()
  }
})

export default router
